(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-calculator-requirements-form"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    const stepOne = document.querySelector('.js-step-one');
    const stepTwo = document.querySelector('.js-step-two');
    const stepThree = document.querySelector('.js-step-three');
    const results = document.querySelector('.js-results');
    const getCheckedValue = function(name) {
        const checkedInput = document.querySelector('input[name="' + name + '"]:checked');

        return checkedInput ? checkedInput.value : '';
    };
    const getStorageKeys = function() {
        return Array.from({ length: localStorage.length }, function(_, index) {
            return localStorage.key(index);
        }).filter(Boolean);
    };

    const nextButtonOne = document.querySelector('.js-next-one');
    const nextButtonTwo = document.querySelector('.js-next-two');
    const backButton = document.querySelector('.js-back');
    const backButtonTwo = document.querySelector('.js-back-two');

    let accordions = document.querySelectorAll('.js-calc-accordion');
    accordions.forEach(openAccordion)
        function openAccordion(accordion) {
            let header = accordion.querySelector('.accordion__header');
            let inner = accordion.querySelector('.accordion__inner');
            let headerButtons = accordion.querySelector('.js-calc-accordion__header-buttons');
            let chunkyPlus = accordion.querySelector('.js-plus-chunky');
            let chunkyMinus = accordion.querySelector('.js-minus-chunky');

            if (inner.classList.contains('hidden')) {
                headerButtons.classList.remove('hidden');
                chunkyPlus.classList.remove('hidden');
                chunkyMinus.classList.add('hidden');
            } else {
                headerButtons.classList.add('hidden');
                chunkyPlus.classList.add('hidden');
                chunkyMinus.classList.remove('hidden');
            }

            header.addEventListener('click', function() {
                    inner.classList.toggle('hidden');
                    headerButtons.classList.toggle('hidden');
                    chunkyPlus.classList.toggle('hidden');
                    chunkyMinus.classList.toggle('hidden');
            return;


            });
        }

    //prevent number inputs accepting non-numeric characters

    const numberInputs = document.querySelectorAll('input[type="number"]');

    numberInputs.forEach(input => {
        input.addEventListener('keydown', function(event) {
            if (event.keyCode === 69) {
                event.preventDefault();
            }
        });
    });

    //REMOVE DISABLED FROM BUTTON ON STEP ONE ONCE AN OPTION HAS BEEN CHOSEN//
    const radioButtonsStepOne = document.querySelectorAll('input[name="calculator-choice"]');

    //if an option is already selected on page load (e.g. after having hit the back button) then remove disabled
    radioButtonsStepOne.forEach(function(radio) {
        if (radio.checked) {
            nextButtonOne.removeAttribute('disabled');
        }
    });

    radioButtonsStepOne.forEach(function(radio) {
        radio.addEventListener('change', function() {
            if (this.checked) {
                nextButtonOne.removeAttribute('disabled');
            }
        });
    });


    //REMOVING DISABLED FROM BUTTON ON STEP TWO PROVIDING ALL FIELDS ARE FILLED IN//
    const fireAssembly = document.querySelector('input[name="fire_assembly"]')
    const solo_employee = document.querySelector('input[name="solo_employee"]')
    const allInputsStepTwo = document.querySelectorAll('.js-step-two input[type="radio"], .js-step-two input[type="number"]');
    const updateStepTwoButtonState = function() {
        if (
            getCheckedValue('workplace-school') !== '' &&
            getCheckedValue('emergency-services') !== '' &&
            getCheckedValue('assessment_carried_out') !== '' &&
            fireAssembly.value !== '' &&
            solo_employee.value !== ''
        ) {
            nextButtonTwo.removeAttribute('disabled');
        } else {
            nextButtonTwo.setAttribute('disabled', 'disabled');
        }
    };

    allInputsStepTwo.forEach(function(input) {
        input.addEventListener('change', updateStepTwoButtonState);
        input.addEventListener('input', updateStepTwoButtonState);
    });
    updateStepTwoButtonState();

    //BUTTONS TO MOVE BETWEEN STEPS//
    nextButtonOne.addEventListener('click', function() {
            stepOne.classList.add('hidden');
            stepTwo.classList.remove('hidden');
            stepTwo.classList.add('flex');
    });

    nextButtonTwo.addEventListener('click', function() {
        stepTwo.classList.add('hidden');

        stepThree.classList.remove('hidden');
        stepThree.classList.add('flex');

        //clear any old data
        localStorage.removeItem('siteData')

        //create local storage for the overall data
        const calculatorChoice = getCheckedValue('calculator-choice');
        const radioSchool = getCheckedValue('workplace-school');
        const radioEmergency = getCheckedValue('emergency-services');
        const radioAssessment = getCheckedValue('assessment_carried_out');
        const fireAssembly = document.querySelector('input[name="fire_assembly"]').value;
        const solo_employee = document.querySelector('input[name="solo_employee"]').value;

        let siteData = {
            calculatorChoice: calculatorChoice,
            radioSchool: radioSchool,
            radioEmergency: radioEmergency,
            radioAssessment: radioAssessment,
            fireAssembly: fireAssembly,
            solo_employee: solo_employee
        };
        localStorage.setItem('siteData', JSON.stringify(siteData));
    });

    backButton.addEventListener('click', function() {
        stepTwo.classList.add('hidden');
        stepOne.classList.remove('hidden');
    });

    backButtonTwo.addEventListener('click', function() {
        stepThree.classList.add('hidden');
        stepTwo.classList.remove('hidden');
    });

    //WHEN THERE'S ONLY ONE AREA, ENSURE THE AREA NAME HAS A VALUE

    const areaNameInput = document.querySelector('input[name="area_name"]');
    const areaNameHeader = document.querySelector('.js-area-name');
     
    areaNameInput.addEventListener('input', function() {
        if (this.value !== '') {
            this.setAttribute('value', this.value);
            areaNameHeader.textContent = this.value;
        } 
    });

    //DUPLICATE AREA//
    let duplicateAreaButtons = document.querySelectorAll('.js-duplicate-area');
    const stepThreeAreas = document.querySelector('.js-step-three-areas');

    duplicateAreaButtons.forEach(function(duplicateAreaButton) {
        let relatedAccordon = duplicateAreaButton.closest('.js-calc-accordion');
        duplicateAreaButton.addEventListener('click', function() {
            duplicateArea(duplicateAreaButton);
        });
    });

    function duplicateArea(duplicateAreaButton) {
        let currentAreaNumber = document.querySelectorAll('.js-calc-accordion').length;
        let newAreaNumber = currentAreaNumber + 1;
        let areaOneAccordion = document.querySelector('.js-area-one-accordion')
        let clickedArea = event.target.closest('.js-calc-accordion');
        let firstArea = document.querySelector('.js-area-one-accordion');

        if (clickedArea === null) {
            clickedArea = firstArea;
        } 

        let newArea = clickedArea.cloneNode(true);

        newArea.classList.remove('js-area-one-accordion', 'hidden', 'js-area-accordion-clone-' + currentAreaNumber);
        newArea.classList.add('js-area-accordion-clone-' + newAreaNumber);

        //APPEND NEW AREA TO DIV//
        stepThreeAreas.appendChild(newArea);


        newArea.querySelector('.accordion__inner').classList.remove('hidden');
    
        //find remove button on new area and remove hidden class

        let removeAreaButtons = newArea.querySelectorAll('.js-remove-area');
        removeAreaButtons.forEach(function(removeAreaButton) {
            removeAreaButton.classList.remove('hidden');
            removeAreaButton.addEventListener('click', function() {
                removeArea(removeAreaButton);
            });
        });

        let newAreaNameInput = newArea.querySelector('input[name="area_name"]');
        let newAreaNameHeader = newArea.querySelector('.js-area-name');

        newAreaNameInput.addEventListener('input', function() {
            if (this.value !== '') {
                this.setAttribute('value', this.value);
                newAreaNameHeader.textContent = this.value;
            } 
        });


        function removeArea(removeAreaButton) {
            let currentAreaNumber = document.querySelectorAll('.js-calc-accordion').length;
            let clickedArea = event.target.closest('.js-calc-accordion');

            //remove the area
            clickedArea.remove();

            //re-number the areas
            let areas = document.querySelectorAll('.js-calc-accordion');
            areas.forEach(function(area, index) {
                area.classList.remove('js-area-accordion-clone-' + (index + 1));
                area.classList.add('js-area-accordion-clone-' + (index + 1));
            });
        }

        //REINITIALISE THE ACCORDIONS

        //get new area accordion with new area number   

        let newAreaAccordion = document.querySelector('.js-area-accordion-clone-' + newAreaNumber);

        //RE-FIND THE BUTTONS SO THE FUNCTION CAN RUN AGAIN//

        let duplicateAreaButtons = newAreaAccordion.querySelectorAll('.js-duplicate-area');
        let addAreaButtons = newAreaAccordion.querySelectorAll('.js-add-area');

        duplicateAreaButtons.forEach(function(duplicateAreaButton) {
            duplicateAreaButton.addEventListener('click', function() {
                duplicateArea(duplicateAreaButton);
            });
        });

        addAreaButtons.forEach(function(addAreaButton) {
            addAreaButton.addEventListener('click', function() {
                addArea(addAreaButton);
            });
        });

        //get the header buttons of the new accordion

        let headerButtons = newAreaAccordion.querySelector('.js-calc-accordion__header-buttons');
        let chunkyPlus = newAreaAccordion.querySelector('.js-plus-chunky');
        let chunkyMinus = newAreaAccordion.querySelector('.js-minus-chunky');
        
        if (newAreaAccordion.querySelector('.accordion__inner').classList.contains('hidden')) {
            headerButtons.classList.remove('hidden');
            chunkyPlus.classList.remove('hidden');
            chunkyMinus.classList.add('hidden');
        } else {
            headerButtons.classList.add('hidden');
            chunkyPlus.classList.add('hidden');
            chunkyMinus.classList.remove('hidden');
        }
    
        newAreaAccordion.querySelector('.accordion__header').addEventListener('click', function() {
            newAreaAccordion.querySelector('.accordion__inner').classList.toggle('hidden');
            headerButtons.classList.toggle('hidden');
            chunkyPlus.classList.toggle('hidden');
            chunkyMinus.classList.toggle('hidden');
        });

        
    }


    //ADD NEW AREA

    let addAreaButtons = document.querySelectorAll('.js-add-area');

    addAreaButtons.forEach(function(addAreaButton) {
        addAreaButton.addEventListener('click', function() {
            addArea();
        });
    });

    function addArea(addAreaButton) {
        //same as the duplicate function but set all inputs to empty
        let currentAreaNumber = document.querySelectorAll('.js-calc-accordion').length;
        let newAreaNumber = currentAreaNumber + 1;
        let clickedArea = event.target.closest('.js-calc-accordion');
        let firstArea = document.querySelector('.js-area-one-accordion');

        if (clickedArea === null) {
            clickedArea = firstArea;
        } 

        let newArea = clickedArea.cloneNode(true);

        //get all inputs in new area and set to empty

        let inputs = newArea.querySelectorAll('input[type="text"], input[type="number"]');
        inputs.forEach(function(input) {
            input.value = '';
        });
        let radios = newArea.querySelectorAll('input[type="radio"]');
        radios.forEach(function(radio) {
            radio.checked = false;
        });
        let checkboxes = newArea.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(function(checkbox) {
            checkbox.checked = false;
        });
        
        newArea.classList.remove('js-area-one-accordion', 'hidden', 'js-area-accordion-clone-' + currentAreaNumber);

        newArea.classList.add('js-area-accordion-clone-' + newAreaNumber);
        newArea.querySelector('.accordion__inner').classList.remove('hidden');


        //APPEND NEW AREA TO DIV//
        stepThreeAreas.appendChild(newArea);
        
        //find remove button on new area and remove hidden class

        let removeAreaButtons = newArea.querySelectorAll('.js-remove-area');
        removeAreaButtons.forEach(function(removeAreaButton) {
            removeAreaButton.classList.remove('hidden');
            removeAreaButton.addEventListener('click', function() {
                removeArea(removeAreaButton);
            });
        });

        let newAreaNameInput = newArea.querySelector('input[name="area_name"]');
        let newAreaNameHeader = newArea.querySelector('.js-area-name');

        newAreaNameInput.addEventListener('input', function() {
            if (this.value !== '') {
                this.setAttribute('value', this.value);
                newAreaNameHeader.textContent = this.value;
            } 
        });

        function removeArea(removeAreaButton) {
            let currentAreaNumber = document.querySelectorAll('.js-calc-accordion').length;
            let clickedArea = event.target.closest('.js-calc-accordion');

            //remove the area
            clickedArea.remove();

            //re-number the areas
            let areas = document.querySelectorAll('.js-calc-accordion');
            areas.forEach(function(area, index) {
                area.classList.remove('js-area-accordion-clone-' + (index + 1));
                area.classList.add('js-area-accordion-clone-' + (index + 1));
            });
        }



        //REINITIALISE THE ACCORDIONS
        let newAreaAccordion = document.querySelector('.js-area-accordion-clone-' + newAreaNumber);

        //RE-FIND THE BUTTONS SO THE FUNCTION CAN RUN AGAIN//

        let duplicateAreaButtons = newAreaAccordion.querySelectorAll('.js-duplicate-area');
        let addAreaButtons = newAreaAccordion.querySelectorAll('.js-add-area');

        duplicateAreaButtons.forEach(function(duplicateAreaButton) {
            duplicateAreaButton.addEventListener('click', function() {
                duplicateArea(duplicateAreaButton);
            });
        });

        addAreaButtons.forEach(function(addAreaButton) {
            addAreaButton.addEventListener('click', function() {
                addArea(addAreaButton);
            });
        });

        //get the header buttons of the new accordion

        let headerButtons = newAreaAccordion.querySelector('.js-calc-accordion__header-buttons');
        let chunkyPlus = newAreaAccordion.querySelector('.js-plus-chunky');
        let chunkyMinus = newAreaAccordion.querySelector('.js-minus-chunky');

        if (newAreaAccordion.querySelector('.accordion__inner').classList.contains('hidden')) {
            headerButtons.classList.remove('hidden');
            chunkyPlus.classList.remove('hidden');
            chunkyMinus.classList.add('hidden');
        } else {
            headerButtons.classList.add('hidden');
            chunkyPlus.classList.add('hidden');
            chunkyMinus.classList.remove('hidden');
        }
    
        newAreaAccordion.querySelector('.accordion__header').addEventListener('click', function() {
            newAreaAccordion.querySelector('.accordion__inner').classList.toggle('hidden');
            headerButtons.classList.toggle('hidden');
            chunkyPlus.classList.toggle('hidden');
            chunkyMinus.classList.toggle('hidden');
        });
        
    }

    
    //CREATE RESULTS//
    
    const resultsButton = document.querySelector('.js-results-button');
    resultsButton.addEventListener('click', function() { 

        //get all area data and put into separate local storage item
        //if there is only one area, get the data from the area one div
    
        //get all areas
        const areas = document.querySelectorAll('.js-calc-accordion');


        //clear local storage of any existing area data
        localStorage.removeItem('areaOneData');
        getStorageKeys().forEach(function(key) {
            if (key.startsWith('areaData')) {
                localStorage.removeItem(key);
            }
        });


    
            //loop through each area, get the data and store in local storage

        areas.forEach(function(area, index) {
            let hazardLevel = 'low';
            let areaName = area.querySelector('input[name="area_name"]').value;
            let shifts = area.querySelector('input[name="shifts"]').value;
            let peoplePerShift = area.querySelector('input[name="people_per_shift"]').value;
            let fireAssembly = document.querySelector('input[name="fire_assembly"]').value;

            //get all hazard checkboxes to assign correct hazard level
            let hazards = area.querySelectorAll('.js-hazard');

            hazards.forEach(function(hazard) {
            if (hazard.checked) {
                hazardLevel = 'high';
                return;
            }
            });

            let vulnerableStaff = area.querySelectorAll('.js-vulnerable');
            let vulnerableStaffChecked = false;
            //if any of the vulnerable staff checkboxes are checked, set hazard level to high

            vulnerableStaff.forEach(function(vulnerable) {
                if (vulnerable.checked) {
                    vulnerableStaffChecked = true
                    return;
                }
            });

            var firstAiders = '';

            if (hazardLevel === 'low') {               
                var firstAiders = shifts;

                if (peoplePerShift > 100) {
                    var firstAiders = Math.ceil(2 * shifts);
                }

                if (peoplePerShift > 199) {
                    var firstAiders = Math.ceil(peoplePerShift / 100 * shifts);
                }
            }; 
            if (hazardLevel === 'high') {    

                var firstAiders = shifts;
                
                if (peoplePerShift > 50) {
                    var firstAiders = Math.ceil(2 * shifts);
                }
                if (peoplePerShift > 100) {
                    var firstAiders = Math.ceil(peoplePerShift / 50 * shifts);
                }
            };

            var fireMarshals = Math.ceil(+shifts);         

                

            //create local storage object for each area
            const areaData = {
                areaName: areaName,
                shifts: shifts,
                peoplePerShift: peoplePerShift,
                hazardLevel: hazardLevel,
                firstAiders: firstAiders,
                fireMarshals: fireMarshals,
                vulnerableStaff: vulnerableStaffChecked,
            };

            localStorage.setItem('areaData' + index, JSON.stringify(areaData));
        });

        
    });

});


    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-calculator-results"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function() {
    // const calculatorResults = document.querySelector('.section-calculator');

    const resultsWrapper = document.querySelector('.js-results-wrapper');
    const getStorageKeys = function() {
        return Array.from({ length: localStorage.length }, function(_, index) {
            return localStorage.key(index);
        }).filter(Boolean);
    };
    const getParsedStorageItem = function(key) {
        const value = localStorage.getItem(key);

        if (!value) {
            return null;
        }

        try {
            return JSON.parse(value);
        } catch (error) {
            return null;
        }
    };
    const toNumber = function(value) {
        const parsedValue = parseInt(value, 10);

        return Number.isNaN(parsedValue) ? 0 : parsedValue;
    };
    const siteData = getParsedStorageItem('siteData') || {};
    const isFireSafetyOnly = (siteData.calculatorChoice || '').toLowerCase() === 'fire safety';
    const allAreaData = getStorageKeys()
        .filter(function(key) {
            return key.startsWith('areaData');
        })
        .sort(function(firstKey, secondKey) {
            return toNumber(firstKey.replace('areaData', '')) - toNumber(secondKey.replace('areaData', ''));
        })
        .map(function(key) {
            return getParsedStorageItem(key);
        })
        .filter(Boolean);


        //FIRST AID KIT CALCULATIONS PER AREA//

        //if area is high hazard, one first aid kit fir every 50 people per shift

        //if area is low hazard, one first aid kit per 100 people per shift

        allAreaData.forEach(function(area) {
            area.peoplePerShift = toNumber(area.peoplePerShift);
            area.shifts = toNumber(area.shifts);

            if (area.hazardLevel === 'high') {
                area.firstAidKitsQty = Math.ceil((area.peoplePerShift * area.shifts) / 50);
            } else {
                area.firstAidKitsQty = Math.ceil((area.peoplePerShift * area.shifts) / 100);
            }

            //if area is high hazard and people per shift is less than 5 recommend medium first aid kit
            //if area is low hazard and people per shift is less than 25 recommend medium first aid kit
            //else recommend large first aid kit

            if (area.hazardLevel === 'high' && area.peoplePerShift < 5) {
                area.firstAidKits = 'Medium First Aid Kit';
            } else if (area.hazardLevel === 'low' && area.peoplePerShift < 25) {
                area.firstAidKits = 'Medium First Aid Kit';
            } else {
                area.firstAidKits = 'Large First Aid Kit';
            }
        });

        // get total medium first aid kits required for all areas

        let totalFirstAidKitsMedium = 0;
        allAreaData.forEach(function(area) {
            area.firstAidKitsQty = toNumber(area.firstAidKitsQty);
            if (area.firstAidKits === 'Medium First Aid Kit') {
                totalFirstAidKitsMedium += area.firstAidKitsQty;
            }
        });

        if (totalFirstAidKitsMedium > 0) {
            const firstAidKitsMedium = document.querySelector('.js-first-aid-kits-medium');
            const firstAidKitsMediumText = document.querySelector('.js-first-aid-kits-medium-total');
            const firstAidKitsMediumQty = document.querySelector('.quantity__input--medium-kit');
            if (firstAidKitsMedium) {
                firstAidKitsMedium.classList.remove('hidden');
                firstAidKitsMedium.parentElement.classList.remove('hidden');
            }
            if (firstAidKitsMediumText) {
                firstAidKitsMediumText.innerHTML = totalFirstAidKitsMedium;
            }
            if (firstAidKitsMediumQty) {
                firstAidKitsMediumQty.value = totalFirstAidKitsMedium;
            }
        }


        //get total large first aid kits required for all areas
        let totalFirstAidKitsLarge = 0;
        allAreaData.forEach(function(area) {
            area.firstAidKitsQty = toNumber(area.firstAidKitsQty);
            if (area.firstAidKits === 'Large First Aid Kit') {
                totalFirstAidKitsLarge += area.firstAidKitsQty;
            }
        });
        if (totalFirstAidKitsLarge > 0) {
            const firstAidKitsLarge = document.querySelector('.js-first-aid-kits-large');
            const firstAidKitsLargeText = document.querySelector('.js-first-aid-kits-large-total');
            const firstAidKitsLargeQty = document.querySelector('.quantity__input--large-kit');
            if (firstAidKitsLarge) {
                firstAidKitsLarge.classList.remove('hidden');
            }
            if (firstAidKitsLargeText) {
                firstAidKitsLargeText.innerHTML = totalFirstAidKitsLarge;
            }
            if (firstAidKitsLargeQty) {
                firstAidKitsLargeQty.value = totalFirstAidKitsLarge;
            }
        }

        if (allAreaData.length > 0) {
            allAreaData.forEach(function(area) {
                //if site calculator choice is fire safety

                if (isFireSafetyOnly) {
                    const areaDataContent = `
                        <div class="bg-contrast-two rounded-sm w-full font-bold text-base p-4 mb-4">
                            <p class="text-primary">${area.areaName}</p>
                            <p class="text-contrast-five"> Fire Marshals: <span class="text-primary">${area.shifts}</span></p>
                        </div>
                    `;

                resultsWrapper.innerHTML += areaDataContent;
                } else {
                    const areaDataContent = `
                        <div class="bg-contrast-two rounded-sm w-full font-bold text-base p-4 mb-4">
                            <p class="text-primary">${area.areaName}</p>
                            <p class="text-contrast-five">First Aiders: <span class="text-primary">${area.firstAiders}</span></p>
                            <p class="text-contrast-five"> Fire Marshals: <span class="text-primary">${area.shifts}</span></p>

                            <div>
                                <p class="text-contrast-five"> ${area.firstAidKits}: <span class="text-primary">${area.firstAidKitsQty}</span></p>
                            </div>
                        </div>
                    `;

                resultsWrapper.innerHTML += areaDataContent;
                }
            });


        }

        let totalEmployees = 0;
        let totalShifts = 0;

        
        allAreaData.forEach(function(area) {
            area.peoplePerShift = toNumber(area.peoplePerShift);
            area.shifts = toNumber(area.shifts);
            totalEmployees += area.peoplePerShift * area.shifts;
            totalShifts += area.shifts;

        });

        //remove leading zeros 
        totalEmployees = totalEmployees.toString().replace(/^0+/, '');
        totalShifts = totalShifts.toString().replace(/^0+/, '');

        const totalEmployeesText = document.querySelector('.js-total-employees');
        const totalShiftsText = document.querySelector('.js-total-shifts');

        if (totalEmployeesText) {
            totalEmployeesText.innerHTML = totalEmployees;
        }
        if (totalShiftsText) {
            totalShiftsText.innerHTML = totalShifts;
        }

        //FIRST AIDER CALCULATIONS (NOTE THAT SOME AREA SPECIFIC ONES ARE DONE IN THE SECTION-CALCULATOR-REQUIREMENTS-FORM FILE)

        //get total first aiders required for all areas
        let totalFirstAiders = 0;
        allAreaData.forEach(function(area) {
            area.firstAiders = toNumber(area.firstAiders);
            totalFirstAiders += area.firstAiders;
        });

        //calculate absence first aiders

        let absenceFirstAiders = Math.ceil(totalFirstAiders / 2);
        let firstAidersIncAbsence = totalFirstAiders + absenceFirstAiders;

        document.querySelector('.js-absence-first-aid__num').innerHTML = absenceFirstAiders;

        if (firstAidersIncAbsence > 0) {
            document.querySelector('.js-first-aiders-total').innerHTML = firstAidersIncAbsence;
        }



        //FIRE MARSHALS CALCULATIONS//

        //get total fire marshals required for all areas
        let totalFireMarshalsAreas = 0;
        allAreaData.forEach(function(area) {
            area.fireMarshals = toNumber(area.fireMarshals);
            totalFireMarshalsAreas += area.fireMarshals;
        });

        let assemblyPoints = siteData.fireAssembly ? toNumber(siteData.fireAssembly) : 0;

        let totalFireMarshalsIncAssembly = totalFireMarshalsAreas + assemblyPoints;

        //round up to nearest integer (half of area fire marshals + assembly points)
        let absenceFireMarshals = Math.ceil(totalFireMarshalsIncAssembly / 2);


        let totalFireMarshals = absenceFireMarshals + totalFireMarshalsIncAssembly;


        if (totalFireMarshals > 0) {
            const fireMarshalCourse = document.querySelector('.js-fire-marshal-course');
            const fireMarshalsTotal = document.querySelector('.js-fire-marshals-total');
            if (fireMarshalCourse) {
                fireMarshalCourse.classList.remove('hidden');
            }
            if (fireMarshalsTotal) {
                fireMarshalsTotal.innerHTML = totalFireMarshals;
            }
        }

        //insert number of assembly points into the js-assembly-fire-marshals

        document.querySelectorAll('.js-assembly-fire-marshals')
            .forEach(function(assemblyPoint) {
                assemblyPoint.innerHTML = assemblyPoints;
            });

        //insert number of absence fire marshals into the js-absence-fire-marshals

        document.querySelector('.js-absence-fire-marshals').innerHTML = absenceFireMarshals;

        
        if (isFireSafetyOnly) {
            const first_aid_area = document.querySelector('.js-first-aid-area');
            if (first_aid_area) {
                first_aid_area.classList.add('hidden');
            }

            const absenceFirstAidersText = document.querySelector('.js-absence-first-aid');
            if (absenceFirstAidersText) {
                absenceFirstAidersText.classList.add('hidden');
            }

            const firstAidKits = document.querySelector('.js-first-aid-kits');
            if (firstAidKits) {
                firstAidKits.classList.add('hidden');
            }
        };
        
        //if any area has been set as high hazard and more than 4 people per shift hide the emergency first aid at work course

        allAreaData.forEach(function(area) {
            const one_day_course = document.querySelector('.js-one-day-course');

            if (one_day_course && area.hazardLevel === 'high' && area.peoplePerShift > 4) {
                one_day_course.classList.add('hidden');
            }
            if (one_day_course && area.vulnerableStaff === true) {
                one_day_course.classList.add('hidden');
            }
        });
});
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => { 
  
  const sections = document.querySelectorAll(
    ".product-recommendations-section"
  );
  

  sections.forEach((section) => {
    if (section) {
      getProductRecommendations(section);
    }
  });
});

function getProductRecommendations(section) {
  const url = section.dataset.url;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector(
        ".product-recommendations-section"
      );

      if (recommendations && recommendations.innerHTML.trim().length) {
        section.innerHTML = recommendations.innerHTML;
      }
    })
    .then(() => {
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        const widgets = document.querySelectorAll(".trustpilot-widget");
        
        if (widgets.length > 0) {
          widgets.forEach(function (widget) {
            try {
              window.Trustpilot.loadFromElement(widget);
            } catch (e) {
              console.debug("Individual Trustpilot widget failed to refresh.");
            }
          });
        }
      }
      initProductRecommendationsSwiper(section);
      section.classList.remove("hidden");
    })
    .catch((e) => {
      console.error(e);
    });
} 

function initProductRecommendationsSwiper(section) {
  const ProductRecommendationsSwiper = section.querySelector(
    ".product-recommendations-swiper"
  );
  if (!ProductRecommendationsSwiper) return;
  // Wait for window.Moonbase.initSwiper to be available before calling it
  function waitForInitSwiper(callback, retries = 20, interval = 100) {
    if (window.Moonbase && typeof window.Moonbase.initSwiper === "function") {
      callback();
    } else if (retries > 0) {
      setTimeout(() => waitForInitSwiper(callback, retries - 1, interval), interval);
    }
  }

  waitForInitSwiper(() => {
    window.Moonbase.initSwiper(ProductRecommendationsSwiper);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-recently-viewed"] && !Shopify.designMode) return;
  try {
    
const localViewed = localStorage.recentlyViewedProduct;
function getRecentlyViewedProducts() {
  const productData = JSON.parse(localStorage.getItem("recentlyViewedProducts"));
  const fullContent = document.querySelector(".recently-viewed-grid");
  const recentlyViewedSection = document.querySelector(".recently-viewed-section");
  const productCardTemplate = document.querySelector("#product-card");
  const recentlyViewedHtml = [];
  const now = new Date();
  const nowTime = Math.floor(now.getTime() / 1000);

  if (productData?.length < 2 || productData == null) {
    recentlyViewedSection.classList.add('!hidden');
    return;
  }

  productDataFiltered = productData?.filter(function(element) {
    return element.id !== window.Moonbase.productJson.id;
  });

  if(productDataFiltered?.length >= 1) {
    Promise.all(productDataFiltered.map(item => {
      return fetch(`/products/${item.handle}`)
        .then(response => {
          if (!response.ok) {
            console.warn(`Product ${item.handle} not found (${response.status})`);
            return null;
          }
          return response.text();
        })
        .then(html => {
          if (!html) return null;
          
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const productCard = doc.querySelector('#product-card');
          
          if (productCard) {
            const newSlide = document.createElement("div");
            newSlide.classList.add("swiper-slide", "!h-auto");
            newSlide.innerHTML = productCard.innerHTML;
            return newSlide;
          }
          return null;
        })
        .catch(error => {
          console.error(`Error fetching product ${item.handle}:`, error);
          return null;
        });
    }))
    .then((results) => {
      // Filter out null results (failed fetches or 404s)
      const validCards = results.filter(card => card !== null);
      
      if (validCards.length < 2) {
        recentlyViewedSection.classList.add('!hidden');
        return;
      }
      
      fullContent.innerHTML = "";
      validCards.forEach(item => {
        fullContent.appendChild(item);
      });
      
      const swiperEl = document.querySelector(".recently-viewed-swiper");
      if(!swiperEl) return;
      
      if (window.SwymCallbacks && window.SwymCallbacks.reinit) {
        window.SwymCallbacks.reinit();
      }
    })
    .then(() => {
      const swiperEl = document.querySelector(".recently-viewed-swiper");
      function waitForInitSwiper(callback, retries = 20, interval = 100) {
      if (window.Moonbase && typeof window.Moonbase.initSwiper === "function") {
        callback();
      } else if (retries > 0) {
        setTimeout(() => waitForInitSwiper(callback, retries - 1, interval), interval);
      }
      }
      waitForInitSwiper(() => {
      window.Moonbase.initSwiper(swiperEl);
      });
    })
    .then(() => {
      if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
        const widgets = document.querySelectorAll(".trustpilot-widget");
        
        if (widgets.length > 0) {
          widgets.forEach(function (widget) {
            try {
              window.Trustpilot.loadFromElement(widget);
            } catch (e) {
              console.debug("Individual Trustpilot widget failed to refresh.");
            }
          });
        }
      }
      if (typeof window.compareGridRender === "function") {
        window.compareGridRender();
      }
    })
    .catch(error => {
      console.error('Error fetching product cards:', error);
    });
  }
}

document.addEventListener("DOMContentLoaded", function (event) {
  getRecentlyViewedProducts();
});

  } catch(e) { console.error(e); }
})();
})();
